/* =============================================
   OWN THEME - JAVASCRIPT
   ============================================= */

(function() {
  'use strict';

  // Initialize theme - merge with window.theme if it exists
  const theme = {
    // Get translations from window.theme
    get translations() {
      return window.theme?.translations || {};
    },
    
    init: function() {
      this.setupSmoothScrolling();
      this.setupProductCards();
      this.setupProductPageFilterChips();
      this.setupHeaderScroll();
      this.setupImageLazyLoading();
      this.setupMegaMenu();
      this.setupMobileMenu();
      this.setupSearchOverlay();
      this.setupLandingPageCarousel();
      this.setupCollectionsCarousel();
    },

    // Markiert Metafeld-Chips auf der Produktdetailseite, wenn URL-Parameter zum Chip-Text passen
    // (z. B. ?tragfaehigkeit=1500%20kg) – Klasse chip--active-filter, Kontrast in theme.css
    setupProductPageFilterChips: function() {
      const container = document.querySelector('.product-card-chips');
      if (!container) return;
      const values = new Set();
      try {
        const raw = sessionStorage.getItem('ownThemePdpChips');
        if (raw) {
          const arr = JSON.parse(raw);
          if (Array.isArray(arr)) {
            for (const item of arr) {
              if (item) values.add(String(item).trim());
            }
          }
          sessionStorage.removeItem('ownThemePdpChips');
        }
      } catch (e) {
        /* */
      }
      const params = new URLSearchParams(window.location.search);
      const skipKeys = new Set(['variant', 'currency', 'country', 'ref', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 's']);
      for (const [key, val] of params) {
        if (skipKeys.has(key.toLowerCase())) continue;
        const decoded = decodeURIComponent(val).trim();
        if (decoded) values.add(decoded);
      }
      if (values.size === 0) return;
      const norm = (s) => s.trim().toLowerCase();
      for (const chip of container.querySelectorAll('.chip')) {
        const t = norm(chip.textContent);
        for (const val of values) {
          const v = norm(val);
          if (t === v) {
            chip.classList.add('chip--active-filter');
            break;
          }
          if (v.length >= 3 && (t.includes(v) || v.includes(t))) {
            chip.classList.add('chip--active-filter');
            break;
          }
        }
      }
    },

    // Smooth scrolling for anchor links
    setupSmoothScrolling: function() {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
          const href = this.getAttribute('href');
          if (href !== '#' && href !== '') {
            const target = document.querySelector(href);
            if (target) {
              e.preventDefault();
              target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }
        });
      });
    },

    // Product card interactions
    setupProductCards: function() {
      const productCards = document.querySelectorAll('.product-card');
      
      productCards.forEach(card => {
        // Add click handler for entire card
        card.addEventListener('click', function(e) {
          // Don't navigate if clicking on a chip or button
          if (e.target.classList.contains('chip') || e.target.closest('.btn')) {
            return;
          }
          
          const link = this.querySelector('.product-card-link');
          if (link) {
            window.location.href = link.href;
          }
        });

        // Intersection Observer for fade-in animation
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('fade-in-up');
              observer.unobserve(entry.target);
            }
          });
        }, {
          threshold: 0.1
        });

        observer.observe(card);
      });
    },

    // Header scroll effect
    setupHeaderScroll: function() {
      const header = document.querySelector('.site-header');
      if (!header) return;
      
      const headerSpacer = document.querySelector('.header-spacer');
      const isSticky = header.dataset.sticky === 'true';
      const marginTop = parseInt(header.dataset.marginTop || 0);
      const headerHeight = parseInt(header.dataset.headerHeight || 64);
      
      let lastScroll = 0;
      let headerOffset = 0;

      // Calculate initial header offset
      const calculateHeaderOffset = () => {
        if (!header.classList.contains('is-sticky')) {
          headerOffset = header.offsetTop;
        }
      };
      
      calculateHeaderOffset();
      window.addEventListener('resize', calculateHeaderOffset);

      window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;

        // Handle sticky behavior
        if (isSticky) {
          if (currentScroll > headerOffset) {
            if (!header.classList.contains('is-sticky')) {
              header.classList.add('is-sticky');
              if (headerSpacer) {
                headerSpacer.classList.add('is-visible');
              }
            }
          } else {
            header.classList.remove('is-sticky');
            if (headerSpacer) {
              headerSpacer.classList.remove('is-visible');
            }
          }
        }

        // Optional: Add shadow on scroll
        const headerTop = header.querySelector('.header-top');
        const shadowTarget = headerTop || header;
        if (currentScroll > 100) {
          shadowTarget.style.boxShadow = '0 2px 16px rgba(0, 0, 0, 0.08)';
        } else {
          shadowTarget.style.boxShadow = '';
        }

        lastScroll = currentScroll;
      });
    },

    // Lazy loading for images
    setupImageLazyLoading: function() {
      if ('loading' in HTMLImageElement.prototype) {
        const images = document.querySelectorAll('img[loading="lazy"]');
        images.forEach(img => {
          img.src = img.dataset.src || img.src;
        });
      } else {
        // Fallback for browsers that don't support lazy loading
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js';
        document.body.appendChild(script);
      }
    },

    // Mega Menu functionality
    setupMegaMenu: function() {
      const megaMenuItems = document.querySelectorAll('.has-mega-menu');
      const overlay = document.querySelector('.mega-menu-overlay');
      let activeTimeout;

      megaMenuItems.forEach(item => {
        const megaMenu = item.querySelector('.mega-menu');
        
        // Desktop: Show on hover
        if (window.innerWidth >= 768 && megaMenu) {
          item.addEventListener('mouseenter', function() {
            clearTimeout(activeTimeout);
            // Close other mega menus
            megaMenuItems.forEach(otherItem => {
              if (otherItem !== item) {
                otherItem.classList.remove('active');
              }
            });
            
            this.classList.add('active');
            if (overlay) {
              overlay.classList.add('active');
            }
          });

          item.addEventListener('mouseleave', function() {
            activeTimeout = setTimeout(() => {
              this.classList.remove('active');
              if (overlay) {
                overlay.classList.remove('active');
              }
            }, 100);
          });
        }
        
        // Mobile: Toggle on click
        const navLink = item.querySelector('.nav-link');
        if (navLink && window.innerWidth < 768) {
          navLink.addEventListener('click', function(e) {
            e.preventDefault();
            const parent = this.closest('.has-mega-menu');
            const isActive = parent.classList.contains('active');
            
            // Close all mega menus
            megaMenuItems.forEach(menuItem => {
              menuItem.classList.remove('active');
            });
            
            // Toggle current mega menu
            if (!isActive) {
              parent.classList.add('active');
            }
          });
        }
      });

      // Close mega menu when clicking overlay
      if (overlay) {
        overlay.addEventListener('click', function() {
          megaMenuItems.forEach(item => {
            item.classList.remove('active');
          });
          this.classList.remove('active');
        });
      }

      // Handle window resize
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          // Re-initialize mega menu behavior
          if (window.innerWidth >= 768) {
            megaMenuItems.forEach(item => {
              item.classList.remove('active');
            });
            if (overlay) {
              overlay.classList.remove('active');
            }
          }
        }, 250);
      });
    },

    // Mobile Menu functionality
    setupMobileMenu: function() {
      // Mobile menu temporarily disabled
      // Nothing happens when clicking the burger menu
    },

    // Search Overlay functionality
    setupSearchOverlay: function() {
      const searchToggle = document.querySelector('.search-toggle');
      const searchOverlay = document.querySelector('.search-overlay');
      const searchClose = document.querySelector('.search-close');
      const searchBackdrop = document.querySelector('.search-overlay-backdrop');
      const searchInput = document.querySelector('.search-input');
      const searchClear = document.querySelector('.search-clear');
      const searchResultsContainer = document.querySelector('.search-results-container');
      const searchResultsGrid = document.querySelector('.search-results-grid');
      const searchSuggestions = document.querySelector('.search-suggestions');
      const searchLoading = document.querySelector('.search-loading');
      const searchEmpty = document.querySelector('.search-empty');
      const searchResultsCount = document.querySelector('.search-results-count');
      const searchViewAll = document.querySelector('.search-view-all');

      if (!searchToggle || !searchOverlay) return;

      let searchTimeout;
      let lastQuery = '';

      // Open search overlay
      const openSearch = () => {
        searchOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        
        // Focus input after animation
        setTimeout(() => {
          if (searchInput) searchInput.focus();
        }, 100);

        // Show suggestions initially
        if (searchSuggestions && searchInput && searchInput.value === '') {
          searchSuggestions.style.display = 'block';
          searchResultsContainer.style.display = 'none';
          searchLoading.style.display = 'none';
          searchEmpty.style.display = 'none';
        }
      };

      // Close search overlay
      const closeSearch = () => {
        searchOverlay.classList.remove('active');
        document.body.style.overflow = '';
        
        // Reset after animation
        setTimeout(() => {
          if (searchInput) {
            searchInput.value = '';
            searchClear.style.display = 'none';
          }
          if (searchSuggestions) searchSuggestions.style.display = 'none';
          if (searchResultsContainer) searchResultsContainer.style.display = 'none';
          if (searchLoading) searchLoading.style.display = 'none';
          if (searchEmpty) searchEmpty.style.display = 'none';
          lastQuery = '';
        }, 300);
      };

      // Event listeners
      searchToggle.addEventListener('click', openSearch);
      searchClose.addEventListener('click', closeSearch);
      searchBackdrop.addEventListener('click', closeSearch);

      // Close on Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
          closeSearch();
        }
      });

      // Clear search input
      if (searchClear) {
        searchClear.addEventListener('click', () => {
          searchInput.value = '';
          searchClear.style.display = 'none';
          searchInput.focus();
          
          // Show suggestions again
          searchSuggestions.style.display = 'block';
          searchResultsContainer.style.display = 'none';
          searchLoading.style.display = 'none';
          searchEmpty.style.display = 'none';
        });
      }

      // Search input handler
      if (searchInput) {
        searchInput.addEventListener('input', function() {
          const query = this.value.trim();
          
          // Show/hide clear button
          if (searchClear) {
            searchClear.style.display = query.length > 0 ? 'block' : 'none';
          }

          // If empty, show suggestions
          if (query.length === 0) {
            searchSuggestions.style.display = 'block';
            searchResultsContainer.style.display = 'none';
            searchLoading.style.display = 'none';
            searchEmpty.style.display = 'none';
            return;
          }

          // Don't search if query is too short
          if (query.length < 2) {
            searchSuggestions.style.display = 'none';
            return;
          }

          // Debounce search
          clearTimeout(searchTimeout);
          searchTimeout = setTimeout(() => {
            performSearch(query);
          }, 300);
        });
      }

      // Perform search using Shopify Predictive Search API
      const performSearch = async (query) => {
        if (query === lastQuery) return;
        lastQuery = query;

        // Show loading state
        searchSuggestions.style.display = 'none';
        searchResultsContainer.style.display = 'none';
        searchLoading.style.display = 'flex';
        searchEmpty.style.display = 'none';

        try {
          const response = await fetch(
            `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`
          );
          
          if (!response.ok) throw new Error('Search failed');
          
          const data = await response.json();
          const products = data.resources.results.products || [];

          searchLoading.style.display = 'none';

          if (products.length === 0) {
            searchEmpty.style.display = 'flex';
            return;
          }

          // Display results
          displaySearchResults(products, query);
          
        } catch (error) {
          console.error('Search error:', error);
          searchLoading.style.display = 'none';
          searchEmpty.style.display = 'flex';
        }
      };

      // Display search results
      const displaySearchResults = (products, query) => {
        searchResultsGrid.innerHTML = '';
        
        products.forEach(product => {
          const item = document.createElement('a');
          item.className = 'search-result-item';
          item.href = product.url;
          
          const imageUrl = product.image ? product.image : '';
          const price = formatMoney(product.price);
          const comparePrice = product.compare_at_price_max && product.compare_at_price_max > product.price
            ? formatMoney(product.compare_at_price_max)
            : '';

          item.innerHTML = `
            <div class="search-result-image">
              ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy">` : ''}
            </div>
            <div class="search-result-info">
              <h4 class="search-result-title">${product.title}</h4>
              ${product.vendor ? `<div class="search-result-vendor">${product.vendor}</div>` : ''}
              <div class="search-result-price">
                ${price}
                ${comparePrice ? `<span class="search-result-price-compare">${comparePrice}</span>` : ''}
              </div>
            </div>
          `;
          
          searchResultsGrid.appendChild(item);
        });

        // Update count and view all link
        if (searchResultsCount) {
          searchResultsCount.textContent = `${products.length} result${products.length !== 1 ? 's' : ''}`;
        }
        
        if (searchViewAll) {
          searchViewAll.href = `/search?q=${encodeURIComponent(query)}`;
        }

        searchResultsContainer.style.display = 'block';
      };

      // Format money helper (basic version)
      const formatMoney = (cents) => {
        const amount = (cents / 100).toFixed(2);
        return `$${amount}`;
      };
    },

    // Product form handler
    handleProductForm: function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const formData = new FormData(form);
        
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          // Show success message
          const successMessage = theme.translations.productAddedToCart || 'Product added to cart!';
          theme.showNotification(successMessage);
          // Update cart count if you have one
          theme.updateCartCount();
        })
        .catch(error => {
          const errorMessage = theme.translations.errorAddingToCart || 'Error adding product to cart';
          theme.showNotification(errorMessage, 'error');
          console.error('Error:', error);
        });
      });
    },

    // Show notification
    showNotification: function(message, type = 'success') {
      if (!message) {
        console.error('showNotification called with empty message');
        return;
      }
      
      const notification = document.createElement('div');
      notification.className = `notification notification-${type}`;
      notification.textContent = message;
      notification.style.cssText = `
        position: fixed;
        top: 80px;
        right: 20px;
        padding: 16px 24px;
        background: ${type === 'success' ? '#34c759' : '#ff3b30'};
        color: white;
        border-radius: 12px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        z-index: 1000;
        animation: slideInRight 0.3s ease-out;
      `;
      
      document.body.appendChild(notification);
      
      setTimeout(() => {
        notification.style.animation = 'slideOutRight 0.3s ease-out';
        setTimeout(() => notification.remove(), 300);
      }, 3000);
    },

    // Update cart count
    updateCartCount: function() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartCount = document.querySelector('.cart-count');
          if (cartCount) {
            cartCount.textContent = cart.item_count;
          }
        });
    },

    // Landing Page Collections Carousel
    setupLandingPageCarousel: function() {
      const carousels = document.querySelectorAll('[data-carousel]');
      
      carousels.forEach(carousel => {
        const track = carousel.querySelector('[data-carousel-track]');
        const prevBtn = carousel.parentElement.querySelector('.landing-video-collections__nav--prev');
        const nextBtn = carousel.parentElement.querySelector('.landing-video-collections__nav--next');
        
        if (!track || !prevBtn || !nextBtn) return;

        const items = track.querySelectorAll('.landing-video-collections__collection-item');
        if (items.length === 0) return;

        // Clone items for infinite scroll effect
        const cloneItems = () => {
          const firstClones = [];
          const lastClones = [];
          
          // Clone first few items and append to end
          for (let i = 0; i < Math.min(3, items.length); i++) {
            const clone = items[i].cloneNode(true);
            clone.classList.add('clone');
            lastClones.push(clone);
          }
          
          // Clone last few items and prepend to start
          for (let i = Math.max(0, items.length - 3); i < items.length; i++) {
            const clone = items[i].cloneNode(true);
            clone.classList.add('clone');
            firstClones.unshift(clone);
          }
          
          firstClones.forEach(clone => track.insertBefore(clone, track.firstChild));
          lastClones.forEach(clone => track.appendChild(clone));
        };

        // Clone items for infinite effect
        if (items.length > 3) {
          cloneItems();
        }

        // Get item width including gap
        const getItemWidth = () => {
          const item = track.querySelector('.landing-video-collections__collection-item');
          if (!item) return 0;
          const style = window.getComputedStyle(track);
          const gap = parseInt(style.gap) || 0;
          return item.offsetWidth + gap;
        };

        // Scroll by one item
        const scrollAmount = () => getItemWidth();

        // Navigation handlers
        const scrollNext = () => {
          const currentScroll = track.scrollLeft;
          const itemWidth = scrollAmount();
          const maxScroll = track.scrollWidth - track.clientWidth;
          
          track.scrollBy({
            left: itemWidth,
            behavior: 'smooth'
          });

          // Check if we need to loop
          setTimeout(() => {
            if (track.scrollLeft >= maxScroll - 10) {
              track.style.scrollBehavior = 'auto';
              track.scrollLeft = itemWidth * 3;
              setTimeout(() => {
                track.style.scrollBehavior = 'smooth';
              }, 50);
            }
          }, 300);
        };

        const scrollPrev = () => {
          const currentScroll = track.scrollLeft;
          const itemWidth = scrollAmount();
          
          track.scrollBy({
            left: -itemWidth,
            behavior: 'smooth'
          });

          // Check if we need to loop
          setTimeout(() => {
            if (track.scrollLeft <= 10) {
              track.style.scrollBehavior = 'auto';
              const allItems = track.querySelectorAll('.landing-video-collections__collection-item');
              track.scrollLeft = track.scrollWidth - track.clientWidth - (itemWidth * 3);
              setTimeout(() => {
                track.style.scrollBehavior = 'smooth';
              }, 50);
            }
          }, 300);
        };

        // Button click handlers
        nextBtn.addEventListener('click', scrollNext);
        prevBtn.addEventListener('click', scrollPrev);

        // Touch swipe support
        let touchStartX = 0;
        let touchEndX = 0;
        let isDragging = false;

        track.addEventListener('touchstart', (e) => {
          touchStartX = e.touches[0].clientX;
          isDragging = true;
        }, { passive: true });

        track.addEventListener('touchmove', (e) => {
          if (!isDragging) return;
          touchEndX = e.touches[0].clientX;
        }, { passive: true });

        track.addEventListener('touchend', () => {
          if (!isDragging) return;
          isDragging = false;
          
          const diff = touchStartX - touchEndX;
          const threshold = 50;

          if (Math.abs(diff) > threshold) {
            if (diff > 0) {
              scrollNext();
            } else {
              scrollPrev();
            }
          }
        });

        // Mouse drag support for desktop
        let mouseStartX = 0;
        let scrollLeft = 0;
        let isMouseDown = false;

        track.addEventListener('mousedown', (e) => {
          isMouseDown = true;
          mouseStartX = e.pageX - track.offsetLeft;
          scrollLeft = track.scrollLeft;
          track.style.cursor = 'grabbing';
          track.style.userSelect = 'none';
        });

        track.addEventListener('mouseleave', () => {
          isMouseDown = false;
          track.style.cursor = 'grab';
        });

        track.addEventListener('mouseup', () => {
          isMouseDown = false;
          track.style.cursor = 'grab';
        });

        track.addEventListener('mousemove', (e) => {
          if (!isMouseDown) return;
          e.preventDefault();
          const x = e.pageX - track.offsetLeft;
          const walk = (x - mouseStartX) * 2;
          track.scrollLeft = scrollLeft - walk;
        });

        // Set initial scroll position (after clones)
        if (items.length > 3) {
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = getItemWidth() * 3;
          setTimeout(() => {
            track.style.scrollBehavior = 'smooth';
          }, 100);
        }

        // Keyboard navigation
        carousel.setAttribute('tabindex', '0');
        carousel.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            scrollPrev();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            scrollNext();
          }
        });
      });
    },

    // New Collections Carousel
    setupCollectionsCarousel: function() {
      const carousel = document.querySelector('.collections-carousel');
      if (!carousel) return;

      const track = carousel.querySelector('.collections-carousel__track');
      const prevBtn = carousel.querySelector('.collections-carousel__btn--prev');
      const nextBtn = carousel.querySelector('.collections-carousel__btn--next');
      const items = carousel.querySelectorAll('.collections-carousel__item');

      if (!track || !prevBtn || !nextBtn || items.length === 0) return;

      // Calculate scroll amount (3 items at a time)
      const getScrollAmount = () => {
        const item = items[0];
        const style = window.getComputedStyle(track);
        const gap = parseInt(style.gap) || 24;
        return (item.offsetWidth + gap) * 3;
      };

      // Check if scroll buttons should be visible
      const updateButtonVisibility = () => {
        const isAtStart = track.scrollLeft <= 0;
        const isAtEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 10;

        prevBtn.style.opacity = isAtStart ? '0.3' : '1';
        prevBtn.style.cursor = isAtStart ? 'default' : 'pointer';
        prevBtn.disabled = isAtStart;

        nextBtn.style.opacity = isAtEnd ? '0.3' : '1';
        nextBtn.style.cursor = isAtEnd ? 'default' : 'pointer';
        nextBtn.disabled = isAtEnd;
      };

      // Scroll to next
      const scrollNext = () => {
        const scrollAmount = getScrollAmount();
        track.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      };

      // Scroll to previous
      const scrollPrev = () => {
        const scrollAmount = getScrollAmount();
        track.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      };

      // Event listeners
      nextBtn.addEventListener('click', scrollNext);
      prevBtn.addEventListener('click', scrollPrev);

      // Update button state on scroll
      track.addEventListener('scroll', updateButtonVisibility);

      // Initial button state
      updateButtonVisibility();

      // Touch/drag support
      let isDragging = false;
      let startX = 0;
      let scrollLeft = 0;

      track.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        track.style.cursor = 'grabbing';
        track.style.userSelect = 'none';
      });

      track.addEventListener('mouseleave', () => {
        isDragging = false;
        track.style.cursor = 'grab';
      });

      track.addEventListener('mouseup', () => {
        isDragging = false;
        track.style.cursor = 'grab';
      });

      track.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 2;
        track.scrollLeft = scrollLeft - walk;
      });

      // Touch support for mobile
      let touchStartX = 0;
      let touchScrollLeft = 0;

      track.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        touchScrollLeft = track.scrollLeft;
      }, { passive: true });

      track.addEventListener('touchmove', (e) => {
        const touchX = e.touches[0].clientX;
        const diff = touchStartX - touchX;
        track.scrollLeft = touchScrollLeft + diff;
      }, { passive: true });

      // Update on resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          updateButtonVisibility();
        }, 250);
      });

      // Keyboard navigation
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          scrollPrev();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          scrollNext();
        }
      });

      // Make track focusable for keyboard navigation
      track.setAttribute('tabindex', '0');
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => theme.init());
  } else {
    theme.init();
  }

  // Setup product forms
  document.addEventListener('DOMContentLoaded', () => {
    const productForms = document.querySelectorAll('.product-form, .product-card-form');
    productForms.forEach(form => theme.handleProductForm(form));
  });

  // Add CSS animations
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideInRight {
      from {
        transform: translateX(400px);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
    
    @keyframes slideOutRight {
      from {
        transform: translateX(0);
        opacity: 1;
      }
      to {
        transform: translateX(400px);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);

  // Expose theme object globally
  window.ownTheme = theme;

})();

